import axios from 'axios'

export const login = async (user: any) => {
  return await axios.post(`${process.env.REACT_APP_API_URL}/login`, user, {
    withCredentials: true,
  })
}
